import { connect } from 'react-redux';
import ScoringStatusBar from '../components/scoring_status_bar';
import {
  startScoringStatusPolling,
  stopScoringStatusPolling,
} from '../actions/scoring_status_index';

const mapStateToProps = (state) => ({
  messages: state.leaderboardV2.scoringStatus,
  timeFormat: state.leaderboardV2.timeFormat,
  roundId: state.leaderboardV2.roundId,
  scoringStatusUrl: state.leaderboardV2.scoringStatusUrl,
});

const mapDispatchToProps = (dispatch) => ({
  startPolling: () => dispatch(startScoringStatusPolling()),
  stopPolling: () => stopScoringStatusPolling(),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScoringStatusBar);
